<template>
    <div class="wrap wrap--main">
    </div>
</template>

<script>
export default {
}
</script>